import API_BASE_URL from "../../ScrapFlow/config/config.server";

const ADMIN_TOKEN_KEY = "adminAuthToken";

export function getAdminToken(): string | null {
  if (typeof window === "undefined") return null;
  return sessionStorage.getItem(ADMIN_TOKEN_KEY);
}

export function setAdminToken(token: string): void {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(ADMIN_TOKEN_KEY, token);
}

export function clearAdminToken(): void {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(ADMIN_TOKEN_KEY);
}

/**
 * fetch() wrapper for every /api/admin/* call in the admin panel: injects the
 * admin's own bearer token (a distinct token space from the rider/marketplace
 * sessionToken — see backend/routes/adminCore.js) and, on a 401, clears it and
 * forces re-login rather than leaving the panel silently broken.
 */
export async function adminFetch(path: string, options: RequestInit = {}): Promise<Response> {
  const token = getAdminToken();
  const url = path.startsWith("http") ? path : `${API_BASE_URL}${path}`;
  const res = await fetch(url, {
    ...options,
    headers: {
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  if (res.status === 401) {
    clearAdminToken();
    if (typeof window !== "undefined") window.location.reload();
  }

  return res;
}
